<template>
  <div class="faqs-page" style="padding-top: 80px;">
    <!-- Our Testimonials -->
    <section class="our-testimonials">
      <div>
        <div class="container mx-auto p-12">
          <div class="mb-12 text-center">
            <h2>FAQs</h2>
          </div>
          <div>
            <ul>
              <li
                v-for="(faq, index) in faqs"
                :key="'faqs' + index"
                class="mb-8"
              >
                <h4 class="mb-4 font-bold">
                  <span class="mr-2">-</span> {{ faq.question }}
                </h4>
                <p class="pl-6" v-html="faq.answer"></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      faqs: [
        {
          question: "Why should I choose Loop Homes?",
          answer:
            "Because we are committed to develop partnerships, based on transparency and mutual trust, which serve to build everlasting relationships with our tenants and landlords. Our property consultants promote long-term success by adhering to a set of common values, which enables us to provide the highest-quality, optimal outcomes for our landlords, tenants, business partners and communities in which we do business and live.",
        },
        {
          question: "In which cities do your offer your services?",
          answer: "We focus on the Northern and Central areas.",
        },
        {
          question: "How can I book a property viewing?",
          answer:
            "<p>You can call us on <a href='tel:+35699173284'>+356 9917 3284</a></p><p class='mb-4'>You can send us an email on <a href='mailto:info@loophomes.com.mt?subject=Mail from Our Site'>info@loophomes.com.mt</a></p><p>You can message us on our social media:</p><p><a href='https://www.facebook.com/loop.homes.mt'>https://www.facebook.com/loop.homes.mt</a></p><p class='mb-4'><a href='https://www.instagram.com/loophomesmt/'>https://www.instagram.com/loophomesmt/</a></p><p>You can message us on our website:</p><p><a href='/contact-us'>https://loophomes.com.mt/contact-us</a></p>",
        },
        {
          question: "What can I do to maximise my rental income?",
          answer:
            "Following our free market appraisal, we will offer advice and detailed changes that could be made to your property to make it more marketable, and to increase its rental value.",
        },
        {
          question:
            "Will a Condition and Inventory reports be issued at the beginning of a tenancy?",
          answer:
            "We recommend that before a tenancy commences the landlord is responsible to prepare Condition and Inventory reports with photographs.",
        },
        {
          question: "What documents do I need to rent a property?",
          answer: "ID or passport",
        },
        {
          question: "How much is the agency fee?",
          answer: "It is 50% of the value of the rental.",
        },
        {
          question: "What bills will I be responsible for?",
          answer:
            "In the majority of cases, you’ll be required to pay all household-related bills associated with a rental property (Internet, water, electricity etc.)",
        },
        {
          question: "Can I redecorate or have pets?",
          answer:
            "When it comes to pets and redecorating, it all comes down to the landlord’s own policy. But be clear with any requests from the start or you could face losing your deposit further down the line.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
input[type="radio"],
input[type="checkbox"] {
  width: 15px;
  height: 15px;
}
/deep/ a {
  @apply underline text-primary-color cursor-pointer;
}
</style>
